export default "__VITE_ASSET__JC_dwJVj__"